import { render, staticRenderFns } from "./dropdown-list.vue?vue&type=template&id=a556cd1a&scoped=true"
import script from "./dropdown-list.vue?vue&type=script&lang=ts"
export * from "./dropdown-list.vue?vue&type=script&lang=ts"
import style0 from "./dropdown-list.vue?vue&type=style&index=0&id=a556cd1a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a556cd1a",
  null
  
)

export default component.exports